import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, PropType, ref } from 'vue'
import { MultiSelect } from '@progress/kendo-vue-dropdowns';
import { filterBy } from '@progress/kendo-data-query';
import { useI18n } from "vue-i18n";
import { Observation } from '@/store/reports/models';
import { Insight } from '@/models/insight';
import { useStore } from "vuex";

// emits

export default /*#__PURE__*/_defineComponent({
  __name: 'IBMultiSelect',
  props: {
  insight: {
    type: Object as PropType<Insight>,
  },
  prefill: {
    type: [Array, String],
  },
  required: {
    type: Boolean,
    default: false,
  }
},
  emits: ['observationChange'],
  setup(__props, { emit }) {

const props = __props;



// store composable
const store = useStore();



const reactiveOptions = ref(props.insight.controller.options.slice())

const { t } = useI18n({
  inheritLocale: true,
  useScope: "local",
});

const translatedItems = reactiveOptions.value.map((option: string) => {
  return t(`config.insight.slide.${store.state.currentSlide.tissueType}.${store.state.currentSlide.stain}.${props.insight.key}.controller.${option}`);
})

const onFilterChange = (event: any) => {
  reactiveOptions.value = filterBy(props.insight.controller.options.slice(), event.filter)
}

const handleChange = (kMultiObj: {value: Array<string>}) => {
  let observation: Observation = {
    key: props.insight.key,
    title: t(`config.insight.slide.${store.getters.GET_ACTIVE_CASE.tissue}.${store.getters.GET_ACTIVE_CASE.stain}.${props.insight.key}.title`),
    value: kMultiObj.value,
  };
  emit("observationChange", observation);
}

const defaultValue = computed( (): Array<any> => {
  if (Array.isArray(props.prefill)) {
    return props.prefill
  } else if (props.prefill) {
    return new Array(props.prefill)
  }
  return []
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(MultiSelect), {
    onFilterchange: onFilterChange,
    filterable: true,
    "data-items": _unref(translatedItems),
    defaultValue: _unref(defaultValue),
    style: {width: '100%'},
    autoClose: false,
    onKeydown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
    popupSettings: {
        className: 'ib-drop-downs',
        height: '600px'
      },
    required: __props.required,
    placeholder: _unref(t)('component.multiselect.placeholder'),
    onChange: handleChange
  }, null, 8, ["data-items", "defaultValue", "required", "placeholder"]))
}
}

})